export const AppRoutes = {
  home: {
    title: "Home",
    route: "/",
    position: 0,
  },
  videos: {
    title: "Videos",
    route: "videos",
    position: 1,
  },
};
